import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  BaseHttpService,
  IBaseResponse,
  IListRequest,
  IListResponse,
  IPaginatedResponse,
} from 'O3_core';
import {
  ICreateTicketCommentRequest,
  ITicketComment,
} from '../models/ticket.interface';

@Injectable({ providedIn: 'root' })
export class TicketCommentService extends BaseHttpService<ITicketComment> {
  constructor() {
    super({ service: 'support', feature: 'ticket-comment', version: 'v1' });
  }

  /** Reporter reply. The server ignores `isInternal` on this path. */
  replyAsReporter(
    data: ICreateTicketCommentRequest,
  ): Observable<ITicketComment> {
    return this.post<IBaseResponse<ITicketComment>>(
      `${this.apiUrl}/my`,
      data,
    ).pipe(map((response) => response.data));
  }

  listMine(data: IListRequest): Observable<IPaginatedResponse<ITicketComment>> {
    return this.post<IListResponse<ITicketComment>>(
      `${this.apiUrl}/my/filter`,
      data,
    ).pipe(map((response) => response.data));
  }

  /** Support/dev authoring. `isInternal` defaults to true server-side. */
  comment(data: ICreateTicketCommentRequest): Observable<ITicketComment> {
    return this.post<IBaseResponse<ITicketComment>>(this.apiUrl, data).pipe(
      map((response) => response.data),
    );
  }

  /**
   * Point at an existing comment as the solution, or demote it again. The
   * server enforces one solution per ticket and refuses internal comments.
   */
  setSolution(
    commentId: string,
    isSolution: boolean,
  ): Observable<ITicketComment> {
    return this.patch<IBaseResponse<ITicketComment>>(
      `${this.apiUrl}/${commentId}/solution`,
      { isSolution },
    ).pipe(map((response) => response.data));
  }
}
